import { render, staticRenderFns } from "./OrganizationMdtDiseasePacs.vue?vue&type=template&id=08b39d69&scoped=true"
import script from "./OrganizationMdtDiseasePacs.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtDiseasePacs.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtDiseasePacs.vue?vue&type=style&index=0&id=08b39d69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b39d69",
  null
  
)

export default component.exports